import api from "@/api/api-updated";

export async function getSalesOrderListAxios() {    
    return await api.get("orders?pageNumber=1&pageSize=10000");
}

export async function deleteSalesOrdersAxios(id) {    
    return await api.delete("orders?Id=" + id);
}

export async function postSalesOrdersAxios(salesorders) {    
    return await api.post("orders", salesorders);
}

export async function putSalesOrdersAxios(salesorders) {    
    return await api.put("orders", salesorders);
}

export async function getSalesOrdersByIDAxios(id) {    
    return await api.get("orders/" + id);
}

export async function getProductOrderAxios(productorder) {    
    return await api.get("orders/getproductorder", productorder);
}

export async function getInventoryCheckAxios(id) {    
    return await api.get("orders/" + id + "/checkinventory");
}


export async function getProformaDocumentList(ReferenceID) {
    return await api.get(`orders/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}

export async function deleteProformaDocument(id) {
    return await api.delete("orders/files/" + id);
}

export async function uploadProformaDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('orders/files/upload', formData);
}

export async function uploadProformaMultipleDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('orders/files/uploads', formData);
}

export async function downloadProformaDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("orders/files/download/" + id);
}
 